export default "__VITE_ASSET__DPyzDbVW__"